import { inject, InjectionToken } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { isApplicationConfigured, isUnauthenticatedTestAccessEnabled } from './auth-config';

export const AUTH_CONFIGURED = new InjectionToken<boolean>('AUTH_CONFIGURED', {
  providedIn: 'root',
  factory: isApplicationConfigured,
});

/**
 * Guards protected routes against a misconfigured auth setup.
 *
 * When authentication and the backend API are configured, this allows activation and defers to `MsalGuard`
 * (registered alongside it on the route), which performs the interactive
 * redirect automatically and returns the user to the requested page. When auth
 * is NOT configured it short-circuits to the login screen so the user sees the
 * configuration error instead of a failed sign-in redirect.
 */
export const authConfiguredGuard: CanActivateFn = (): boolean | UrlTree => {
  if (inject(AUTH_CONFIGURED)) {
    return true;
  }

  return inject(Router).createUrlTree(['/login']);
};

export const protectedGuards = isUnauthenticatedTestAccessEnabled()
  ? []
  : [authConfiguredGuard, MsalGuard];
